import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { ref, watch } from 'vue';
export default {
  name: 'RemoteSelect',
  props: {
    // 传入的默认值
    value: {
      type: [String, Number],
      default: ''
    },
    // 远程搜索方法，需要返回 Promise
    fetchOptions: {
      type: Function,
      required: true
    },
    // 是否在初始化时自动根据value搜索
    initSearch: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    labelkey: {
      type: String,
      default: 'label'
    },
    valuekey: {
      type: String,
      default: 'value'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请输入关键词搜索'
    }
  },
  emits: ['change', 'update:value'],
  setup(props, _ref) {
    var {
      emit
    } = _ref;
    var options = ref([]);
    var selectedValue = ref('');
    var loading = ref(false);

    // 远程搜索方法
    var remoteMethod = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (query) {
        if (query !== '') {
          loading.value = true;
          try {
            var data = yield props.fetchOptions(query);
            options.value = data;
          } catch (error) {
            console.error('远程搜索失败:', error);
            options.value = [];
          } finally {
            loading.value = false;
          }
        } else {
          // options.value = []
        }
      });
      return function remoteMethod(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    // 根据value值获取选项
    var searchByValue = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* () {
        if (!props.value) {
          selectedValue.value = '';
          // options.value = []
          return;
        }
        loading.value = true;
        try {
          // 这里假设你的远程接口支持根据ID/value搜索
          var data = yield props.fetchOptions(props.value, true);
          if (data && data.length > 0) {
            options.value = data;
            selectedValue.value = props.value;
          } else {
            selectedValue.value = '';
            // options.value = []
          }
        } catch (error) {
          console.error('根据value搜索失败:', error);
          selectedValue.value = '';
          // options.value = []
        } finally {
          loading.value = false;
        }
      });
      return function searchByValue() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 处理选择变化
    var handleChange = value => {
      console.log('选择变化', value);
      if (value && !props.multiple) {
        var obj = options.value.find(x => x[props.valuekey] == value);
        console.log('obj', {
          obj
        });
        emit('change', value, obj);
      } else if (value && props.multiple) {
        var arr = [];
        options.value.map(x => {
          if (value.indexOf(x[props.valuekey]) !== -1) {
            arr.push(x);
          }
        });
        console.log('arr', {
          arr
        });
        emit('change', value, arr);
      } else {
        emit('change', value);
      }
      emit('update:value', value);
    };

    // 监听value变化
    watch(() => props.value, newVal => {
      console.log('value变化:', newVal, selectedValue.value);
      if (newVal !== selectedValue.value) {
        searchByValue();
      }
    }, {
      immediate: props.initSearch
    });
    return {
      options,
      selectedValue,
      loading,
      remoteMethod,
      handleChange
    };
  }
};